"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ToastNotification_1 = __importDefault(require("./components/ToastNotification/ToastNotification"));
var prop_types_1 = __importDefault(require("prop-types"));
var NavTree_1 = __importDefault(require("./components/NavTree/NavTree"));
var ResizableLeftPanel_1 = __importDefault(require("./components/ResizableLeftPanel/ResizableLeftPanel"));
var NavPanelUtils_1 = require("./components/NavPanelUtils/NavPanelUtils");
var l10n_1 = __importDefault(require("@paprika/l10n"));
var locales_1 = __importDefault(require("../locales"));
var DEFAULT_PANEL_WIDTH = 350;
var NO_SCROLL_TYPES = ['storyboard', 'metric', 'interpretation', 'records'];
var FULL_STATS_TIMEOUT = 30000;
var NavigationPage = /** @class */ (function (_super) {
    __extends(NavigationPage, _super);
    function NavigationPage(props) {
        var _this = _super.call(this, props) || this;
        _this.flattenedItems = [];
        _this.fullStatsTimeoutPassed = function () {
            if (!_this.state.fullStatsRequestedAt) {
                return true;
            }
            return new Date() - _this.state.fullStatsRequestedAt > FULL_STATS_TIMEOUT;
        };
        _this.fetchNavItems = function (trackTimeout) {
            var fullStatsRequested = _this.state.fullStatsRequested;
            if (fullStatsRequested || !_this.fullStatsTimeoutPassed()) {
                return;
            }
            var stateChanges = { fullStatsRequested: true };
            if (trackTimeout) {
                stateChanges.fullStatsRequestedAt = new Date();
            }
            _this.setState(stateChanges);
            _this.props.getNavItems().then(function (data) {
                var items = data.items, canViewSettings = data.canViewSettings, hasFullStats = data.hasFullStats;
                _this.makePathsAbsolute(items);
                _this.flattenedItems = _this.flattenItems(items);
                _this.setState({
                    canViewSettings: canViewSettings,
                    items: items,
                    hasFullStats: hasFullStats,
                    fullStatsRequested: false,
                });
                _this.props.setToSessionStorage('items', items);
                _this.props.setToSessionStorage('canViewSettings', canViewSettings);
                _this.props.setToSessionStorage('hasFullStats', hasFullStats);
            });
            _this.scrollNavContainer();
            _this.setNavItemHighlight();
        };
        _this.makePathsAbsolute = function (items) {
            items.forEach(function (item) {
                item.path = _this.absolutePathForItem(item.path, item.type);
                if (item.childItems) {
                    _this.makePathsAbsolute(item.childItems);
                }
            });
        };
        _this.absolutePathForItem = function (path, type) {
            var hostUrl = type === NavPanelUtils_1.ItemType.Header.Storyboards || type === NavPanelUtils_1.ItemType.Storyboard
                ? _this.props.storyboardsUrl
                : _this.props.resultsUrl;
            return "" + hostUrl + path;
        };
        // TODO Need to fix this using _.flattenDeep(array) using lodash.
        _this.flattenItems = function (items) {
            var flatItems = [];
            var excludedItemTypes = [
                NavPanelUtils_1.ItemType.Header.Storyboards,
                NavPanelUtils_1.ItemType.Header.Projects,
                NavPanelUtils_1.ItemType.Records,
                NavPanelUtils_1.ItemType.Header.Interpretations,
                NavPanelUtils_1.ItemType.Header.Metrics,
                NavPanelUtils_1.ItemType.Header.Triggers,
            ];
            items.forEach(function (item) {
                if (excludedItemTypes.indexOf(item.type) === -1) {
                    var childItems = item.childItems, flatItem = __rest(item, ["childItems"]);
                    flatItems.push(flatItem);
                }
                if (item.childItems && item.childItems.length > 0) {
                    flatItems = flatItems.concat(_this.flattenItems(item.childItems));
                }
            });
            return flatItems;
        };
        _this.scrollNavContainer = function () {
            var navScrollOffset = _this.props.navScrollOffset;
            _this.props.setToSessionStorage('navScrollOffset', null);
            var container;
            var target;
            if (navScrollOffset) {
                container = document.getElementsByClassName('results-panel__body')[0];
                target = document.getElementById(navScrollOffset);
            }
            if (container && target) {
                var offset = container.getBoundingClientRect().top + container.clientHeight / 2;
                var scrollTop = target.getBoundingClientRect().top - offset;
                container.scrollTop = scrollTop;
            }
        };
        _this.setNavItemHighlight = function () {
            var _a = _this.state, expanded = _a.expanded, location = _a.location;
            if (location.projects) {
                var project_titles = _this.state.items.filter(function (item) { return item.type === NavPanelUtils_1.ItemType.Header.Projects; });
                var project_title_id_1;
                project_titles.forEach(function (project) {
                    if (project.childItems.filter(function (child) { return child.id === location.projects; }).length !== 0) {
                        project_title_id_1 = project.id;
                    }
                });
                if (expanded.projects && expanded.projects.indexOf(project_title_id_1) === -1) {
                    expanded.projects.push(project_title_id_1);
                }
                location.project_title_id = project_title_id_1;
                _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Project, location.projects);
            }
            if (location.storyboards) {
                expanded.storyboards = [1];
                _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Storyboard, location.storyboards);
            }
            if (location.controls) {
                _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Control, location.controls);
            }
            if (location.control_tests) {
                var controlTest = _this.findControlTest(location.control_tests);
                if (controlTest) {
                    _this.addToExpanded(expanded, controlTest.type, location.control_tests);
                }
            }
            if (location.interpretations) {
                _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Header.Interpretations, "controlTest_" + location.control_tests + "_interpretations");
                if (!isNaN(location.interpretations)) {
                    _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Interpretation, location.interpretations);
                }
            }
            if (location.metrics) {
                _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Header.Metrics, "controlTest_" + location.control_tests + "_metrics");
                if (!isNaN(location.metrics)) {
                    _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Metric, location.metrics);
                }
            }
            _this.props.setToSessionStorage('expanded', expanded);
            _this.setState({ expanded: expanded, location: location });
        };
        _this.addToExpanded = function (expanded, key, item) {
            if (!expanded[key]) {
                expanded[key] = [];
            }
            if (!expanded[key].includes(item)) {
                expanded[key].push(item);
            }
        };
        _this.caretClickHandler = function (expanded) {
            _this.props.setToSessionStorage('expanded', expanded);
            _this.setState({ expanded: expanded });
        };
        _this.navigationHandler = function (e, type, ids, path) {
            var pathName = path || '/';
            _this.props.setToSessionStorage('navScrollOffset', "nav-item_" + type + "_" + ids.id);
            if (window.location.pathname === pathName) {
                if (e && pathName.indexOf('#') < 0) {
                    e.preventDefault();
                }
                var _a = _this.scrollTarget(type, ids), targetDomElement = _a.targetDomElement, event_1 = _a.event, eventTarget = _a.eventTarget;
                if (targetDomElement) {
                    if (type !== NavPanelUtils_1.ItemType.Header.Storyboards && type !== NavPanelUtils_1.ItemType.Header.Projects) {
                        _this.highlightElement(targetDomElement);
                    }
                    _this.smoothScrollIntoView(targetDomElement, 500);
                    if (eventTarget && event_1) {
                        eventTarget.dispatchEvent(event_1);
                    }
                }
                else {
                    _this.setState({ showToast: true });
                }
            }
            else if (NO_SCROLL_TYPES.indexOf(type) === -1) {
                _this.props.setToSessionStorage('scrollTarget', [type, ids, path]);
            }
        };
        _this.getScrollTargetDomElement = function (type, ids) {
            switch (type) {
                case NavPanelUtils_1.ItemType.Header.Storyboards:
                    return document.getElementsByClassName('storyboards')[0];
                case NavPanelUtils_1.ItemType.Header.Projects:
                    return document.getElementsByClassName('projects-index')[0];
                case NavPanelUtils_1.ItemType.Project:
                    return document.getElementsByClassName('project-show-page')[0];
                case NavPanelUtils_1.ItemType.Control:
                    return document.getElementById("control-" + ids.id + "-container");
                case NavPanelUtils_1.ItemType.Header.Triggers:
                case NavPanelUtils_1.ItemType.Trigger:
                case NavPanelUtils_1.ItemType.Header.Interpretations:
                case NavPanelUtils_1.ItemType.Header.Metrics:
                    return document.getElementById("control-test-title-" + ids.controlTestId);
                default:
                    return null;
            }
        };
        _this.getScrollEventTarget = function (type, ids) {
            switch (type) {
                case NavPanelUtils_1.ItemType.Header.Triggers: {
                    var eventTarget = document.getElementById("control-test-" + ids.controlTestId + "-trigger_count");
                    delete eventTarget.editTriggerId;
                    return eventTarget;
                }
                case NavPanelUtils_1.ItemType.Trigger: {
                    var eventTarget = document.getElementById("control-test-" + ids.controlTestId + "-trigger_count");
                    eventTarget.editTriggerId = ids.id;
                    return eventTarget;
                }
                case NavPanelUtils_1.ItemType.Header.Interpretations:
                    return document.getElementById("control-test-" + ids.controlTestId + "-interpretation_count");
                case NavPanelUtils_1.ItemType.Header.Metrics:
                    return document.getElementById("control-test-" + ids.controlTestId + "-metric_count");
                default:
                    return null;
            }
        };
        _this.getScrollEvent = function () {
            return new MouseEvent('click', { view: window, bubbles: true, cancelable: true });
        };
        _this.getTargetDomElement = function (type, ids) {
            var scrollTargetDomElement = _this.getScrollTargetDomElement(type, ids);
            if (scrollTargetDomElement) {
                return scrollTargetDomElement;
            }
            if (NavPanelUtils_1.isTableType(type)) {
                return document.getElementById("control-test-title-" + ids.id).closest('tr');
            }
            return null;
        };
        _this.scrollTarget = function (type, ids) {
            var targetDomElement = _this.getTargetDomElement(type, ids);
            var event = NavPanelUtils_1.isModalType(type) ? _this.getScrollEvent() : null;
            var eventTarget = NavPanelUtils_1.isModalType(type) ? _this.getScrollEventTarget(type, ids) : null;
            return { targetDomElement: targetDomElement, event: event, eventTarget: eventTarget };
        };
        _this.highlightElement = function (element) {
            element.className += ' navigation-highlight';
            window.setTimeout(function () {
                element.className = element.className.replace(' navigation-highlight', '');
            }, 750);
        };
        _this.smoothScrollIntoView = function (target, animationDuration) {
            var container = document.getElementsByClassName('results-body-container')[0];
            var scrollPadding = 30;
            var originalYOffset = container.scrollTop;
            var elementOffset = target.getBoundingClientRect().top - container.getBoundingClientRect().top;
            var totalScrollDistance = elementOffset - scrollPadding;
            var start;
            var step = function (timestamp) {
                if (!start) {
                    start = timestamp;
                }
                var elapsedTime = timestamp - start;
                var percentComplete = elapsedTime / animationDuration;
                var weightedPercent = _this.easing(percentComplete);
                container.scrollTop = originalYOffset + totalScrollDistance * weightedPercent;
                if (elapsedTime < animationDuration) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        };
        _this.easing = function (t) { return (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1); };
        _this.resizeHandler = function (width, backupWidth) {
            _this.setState({ width: width, backupWidth: backupWidth }, function () {
                _this.props.setToSessionStorage('width', width);
                _this.props.setToSessionStorage('backupWidth', backupWidth);
            });
            _this.afterResizeCallback();
        };
        _this.afterResizeCallback = function () {
            if (window.afterResizeCallback) {
                window.afterResizeCallback();
            }
        };
        _this.searchChangeHandler = function (searchValue) {
            clearTimeout(_this.performSearchTimeout);
            var showSearchPopover = false;
            if (_this.props && _this.props.locale !== 'zh' && _this.props.locale !== 'ja') {
                showSearchPopover = searchValue.trim().length === 1;
            }
            _this.performSearchTimeout = setTimeout(function () {
                _this.performSearch(searchValue);
                _this.setState({ showSearchPopover: showSearchPopover });
            }, 400);
            _this.setState({ searchValue: searchValue });
        };
        _this.performSearch = function (value) {
            var searchValues = value
                .toLowerCase()
                .split(' ')
                .filter(function (val) { return val.length > 0; });
            var backupExpanded = _this.state.backupExpanded || _this.state.expanded;
            var expanded;
            var searchIds;
            var noSearchResults;
            var longEnoughValue = true;
            if (_this.props && _this.props.locale !== 'zh' && _this.props.locale !== 'ja') {
                longEnoughValue = value.trim().length > 1;
            }
            if (longEnoughValue && searchValues.length > 0) {
                expanded = {
                    storyboards: [1],
                    projects: [1],
                };
                var headers = {
                    storyboards: [],
                    projects: [],
                    metrics: [],
                    triggers: [],
                    interpretations: [],
                };
                var storyboardItems = {
                    storyboard: [],
                };
                var collectionItems = {
                    project: [],
                    control: [],
                    'DataTables::DataAnalytic': [],
                    'DataTables::Survey': [],
                    'DataTables::EventReport': [],
                    'DataTables::Reporting': [],
                    interpretation: [],
                    metric: [],
                    trigger: [],
                };
                searchIds = __assign(__assign(__assign({}, headers), storyboardItems), collectionItems);
                var matchedItems = _this.flattenedItems.filter(function (item) {
                    var name = item.name.toLowerCase();
                    return searchValues.every(function (searchValue) { return name.includes(searchValue); });
                });
                noSearchResults = matchedItems.length === 0;
                matchedItems.forEach(function (item) {
                    if (searchIds[item.type]) {
                        searchIds[item.type].push(item.id);
                    }
                    _this.addToExpanded(expanded, item.type, item.id);
                    if (item.projectId) {
                        searchIds.project.push(item.projectId);
                        _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Project, item.projectId);
                    }
                    if (item.controlId) {
                        searchIds.control.push(item.controlId);
                        _this.addToExpanded(expanded, NavPanelUtils_1.ItemType.Control, item.controlId);
                    }
                    if (item.controlTestId) {
                        var controlTest = _this.findControlTest(item.controlTestId);
                        if (controlTest) {
                            searchIds[controlTest.type].push(item.controlTestId);
                            _this.addToExpanded(expanded, controlTest.type, item.controlTestId);
                        }
                    }
                    if ([NavPanelUtils_1.ItemType.Interpretation, NavPanelUtils_1.ItemType.Metric, NavPanelUtils_1.ItemType.Trigger].includes(item.type)) {
                        var pluralType = item.type + "s";
                        searchIds[pluralType].push("controlTest_" + item.controlTestId + "_" + pluralType);
                        _this.addToExpanded(expanded, pluralType, "controlTest_" + item.controlTestId + "_" + pluralType);
                    }
                });
                if (searchIds.storyboard.length > 0) {
                    searchIds.storyboards.push(1);
                }
                var collectionSearch = Object.keys(collectionItems).find(function (item) {
                    return searchIds[item].length;
                });
                if (collectionSearch) {
                    searchIds.projects.push(1);
                }
            }
            else {
                expanded = backupExpanded;
                backupExpanded = null;
                searchIds = null;
                searchValues = null;
                noSearchResults = false;
            }
            _this.setState({ searchIds: searchIds, expanded: expanded, backupExpanded: backupExpanded, searchValues: searchValues, noSearchResults: noSearchResults });
        };
        _this.findControlTest = function (controlTestId) {
            return _this.flattenedItems.find(function (item) { return NavPanelUtils_1.isTableType(item.type) && item.id === controlTestId; });
        };
        _this.collapseToggleHandler = function (collapsed) {
            if (!_this.state.hasFullStats && !collapsed) {
                _this.fetchNavItems(true);
            }
        };
        var items = props.items || [];
        var expanded = props.expanded || {};
        var width = props.width || 0; // collapsed
        var backupWidth = props.backupWidth || DEFAULT_PANEL_WIDTH;
        var scrollTarget = props.scrollTarget || null;
        var canViewSettings = props.canViewSettings;
        var location = NavPanelUtils_1.NavPanelUtils.parseLocation(window.location.pathname, window.location.hash);
        _this.state = {
            items: items,
            expanded: expanded,
            width: width,
            backupWidth: backupWidth,
            scrollTarget: scrollTarget,
            canViewSettings: canViewSettings,
            location: location,
            showToast: false,
            searchIds: null,
            searchValues: null,
            searchValue: '',
            showSearchPopover: false,
            noSearchResults: false,
            hasFullStats: false,
            fullStatsRequested: false,
            fullStatsRequestedAt: null,
            locale: props.locale || 'en',
        };
        return _this;
    }
    NavigationPage.prototype.componentDidMount = function () {
        var _this = this;
        this.fetchNavItems(false);
        if (this.state.scrollTarget) {
            if (this.state.scrollTarget[2] === window.location.pathname) {
                this.navigationHandler.apply(this, __spreadArrays([null], this.state.scrollTarget));
            }
            this.props.setToSessionStorage('scrollTarget', null);
        }
        window.onhashchange = function () {
            return _this.setState({
                location: NavPanelUtils_1.NavPanelUtils.parseLocation(window.location.pathname, window.location.hash, _this.props.AclExceptionProjectId, _this.props.AclExceptionControlId, _this.props.AclExceptionControlTestId),
            });
        };
    };
    NavigationPage.prototype.renderToast = function () {
        var _this = this;
        if (this.state.showToast) {
            return (react_1.default.createElement(ToastNotification_1.default, { handleClose: function () {
                    _this.setState({ showToast: false });
                } }));
        }
        return null;
    };
    NavigationPage.prototype.render = function () {
        return (react_1.default.createElement(l10n_1.default, { locale: this.state.locale, locales: locales_1.default },
            react_1.default.createElement(ResizableLeftPanel_1.default, { width: this.state.width, backupWidth: this.state.backupWidth || DEFAULT_PANEL_WIDTH, onResize: this.resizeHandler, afterResizeCallback: this.afterResizeCallback, canViewSettings: this.state.canViewSettings, onSearchChange: this.searchChangeHandler, searchValue: this.state.searchValue, showSearchPopover: this.state.showSearchPopover, collapseToggleCallback: this.collapseToggleHandler, storyboardsUrl: this.props.storyboardsUrl, resultsUrl: this.props.resultsUrl },
                this.renderToast(),
                react_1.default.createElement(NavTree_1.default, { items: this.state.items, searchIds: this.state.searchIds, searchValues: this.state.searchValues, expanded: this.state.expanded, location: this.state.location, onCaretClick: this.caretClickHandler, onNavigate: this.navigationHandler, noSearchResults: this.state.noSearchResults }))));
    };
    NavigationPage.propTypes = {
        storyboardsUrl: prop_types_1.default.string,
        resultsUrl: prop_types_1.default.string,
        items: prop_types_1.default.array,
        expanded: prop_types_1.default.object,
        width: prop_types_1.default.number,
        backupWidth: prop_types_1.default.number,
        scrollTarget: prop_types_1.default.array,
        canViewSettings: prop_types_1.default.bool,
        locale: prop_types_1.default.string,
        navScrollOffset: prop_types_1.default.string,
        AclExceptionProjectId: prop_types_1.default.string,
        AclExceptionControlId: prop_types_1.default.string,
        AclExceptionControlTestId: prop_types_1.default.string,
        setToSessionStorage: prop_types_1.default.func,
        getNavItems: prop_types_1.default.func,
    };
    NavigationPage.defaultProps = {
        storyboardsUrl: '',
        resultsUrl: '',
        setToSessionStorage: function () { },
        getNavItems: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, {}];
            });
        }); },
    };
    return NavigationPage;
}(react_1.default.Component));
exports.default = NavigationPage;
//# sourceMappingURL=NavigationPage.js.map